import { createTheme, type MantineTheme, Title } from '@mantine/core';
import type { PartialDeep } from 'type-fest';

import { colorsTheme } from '../colors';

export const ThemedMantineTitle: PartialDeep<MantineTheme> = createTheme({
  components: {
    Title: Title.extend({
      defaultProps: {
        c: colorsTheme.colors?.black![0],
      },
    }),
  },
});
